export const ToneChatIcon = ({ accessibilityLabel }: { readonly accessibilityLabel: string }) => {
  const isDecorative = accessibilityLabel === ''

  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={isDecorative}
      aria-label={accessibilityLabel}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9135 19.2002C5.75758 19.2002 3.19922 21.7586 3.19922 24.9145V73.5591L15.4082 64.0002H58.2849C61.4408 64.0002 63.9992 61.4418 63.9992 58.2859V24.9145C63.9992 21.7586 61.4408 19.2002 58.2849 19.2002H8.9135Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.69922 24.9145C2.69922 21.4824 5.48144 18.7002 8.9135 18.7002H58.2849C61.717 18.7002 64.4992 21.4824 64.4992 24.9145V58.2859C64.4992 61.718 61.717 64.5002 58.2849 64.5002H15.5807L3.50745 73.9528C3.35686 74.0707 3.15221 74.0924 2.98026 74.0086C2.80832 73.9249 2.69922 73.7504 2.69922 73.5591V24.9145ZM8.9135 19.7002C6.03373 19.7002 3.69922 22.0347 3.69922 24.9145V72.5326L15.1 63.6065C15.1879 63.5376 15.2965 63.5002 15.4082 63.5002H58.2849C61.1647 63.5002 63.4992 61.1657 63.4992 58.2859V24.9145C63.4992 22.0347 61.1647 19.7002 58.2849 19.7002H8.9135Z"
        fill="#1C1C1C"
      />
      <path
        d="M33.5992 56.0002C41.5521 56.0002 47.9992 49.5531 47.9992 41.6002C47.9992 33.6473 41.5521 27.2002 33.5992 27.2002C25.6463 27.2002 19.1992 33.6473 19.1992 41.6002C19.1992 49.5531 25.6463 56.0002 33.5992 56.0002Z"
        fill="#D5FF00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6992 41.6002C18.6992 33.3711 25.3702 26.7002 33.5992 26.7002C41.8283 26.7002 48.4992 33.3711 48.4992 41.6002C48.4992 49.8293 41.8283 56.5002 33.5992 56.5002C25.3702 56.5002 18.6992 49.8293 18.6992 41.6002ZM33.5992 27.7002C25.9224 27.7002 19.6992 33.9234 19.6992 41.6002C19.6992 49.277 25.9224 55.5002 33.5992 55.5002C41.276 55.5002 47.4992 49.277 47.4992 41.6002C47.4992 33.9234 41.276 27.7002 33.5992 27.7002Z"
        fill="#1C1C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.1836 46.0848C38.357 45.8717 38.6702 45.8383 38.8846 46.0107C39.0999 46.1836 39.1342 46.4983 38.9612 46.7136L38.5714 46.4004C38.9612 46.7136 38.961 46.7138 38.9608 46.7141L38.9604 46.7145L38.9595 46.7156L38.9574 46.7182L38.9517 46.7252L38.9342 46.7457C38.9199 46.7622 38.9002 46.7843 38.8751 46.8111C38.8248 46.8648 38.7525 46.9375 38.6573 47.0228C38.467 47.1934 38.1844 47.4147 37.8026 47.634C37.0359 48.0743 35.8793 48.5004 34.2857 48.5004C32.7006 48.5004 31.5826 48.1155 30.8296 47.6914C30.4548 47.4803 30.1757 47.2624 29.9778 47.0845C29.8142 46.9374 29.6247 46.733 29.6522 46.7596C29.4538 46.5675 29.4487 46.2509 29.6408 46.0526C29.8329 45.8542 30.1495 45.8491 30.3478 46.0412C30.3642 46.0571 30.3843 46.0786 30.409 46.1049C30.5427 46.2477 30.8091 46.5321 31.3204 46.8201C31.9222 47.1591 32.8709 47.5004 34.2857 47.5004C35.6921 47.5004 36.6783 47.1265 37.3045 46.7668C37.6191 46.5861 37.8456 46.4075 37.99 46.278C38.0622 46.2133 38.1138 46.1611 38.1456 46.1272C38.1614 46.1103 38.1723 46.098 38.1783 46.091L38.1836 46.0849L38.1828 46.0858L38.1823 46.0864L38.182 46.0868C38.1825 46.0861 38.1831 46.0855 38.1836 46.0848ZM38.1836 46.0849C38.1839 46.0845 38.1839 46.0845 38.1836 46.0848L38.1836 46.0848M38.1836 46.0848L38.1836 46.0849L38.1836 46.0848Z"
        fill="#1C1C1C"
      />
      <path
        d="M27.9984 39.9998C28.8821 39.9998 29.5984 39.2835 29.5984 38.3998C29.5984 37.5161 28.8821 36.7998 27.9984 36.7998C27.1148 36.7998 26.3984 37.5161 26.3984 38.3998C26.3984 39.2835 27.1148 39.9998 27.9984 39.9998Z"
        fill="#1C1C1C"
      />
      <path
        d="M39.2016 39.9998C40.0852 39.9998 40.8016 39.2835 40.8016 38.3998C40.8016 37.5161 40.0852 36.7998 39.2016 36.7998C38.3179 36.7998 37.6016 37.5161 37.6016 38.3998C37.6016 39.2835 38.3179 39.9998 39.2016 39.9998Z"
        fill="#1C1C1C"
      />
      <path
        d="M62.4 32.0002C70.3529 32.0002 76.8 25.5531 76.8 17.6002C76.8 9.6473 70.3529 3.2002 62.4 3.2002C54.4471 3.2002 48 9.6473 48 17.6002C48 25.5531 54.4471 32.0002 62.4 32.0002Z"
        fill="#00E0AC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4 3.7002C54.7232 3.7002 48.5 9.92344 48.5 17.6002C48.5 25.277 54.7232 31.5002 62.4 31.5002C70.0768 31.5002 76.3 25.277 76.3 17.6002C76.3 9.92344 70.0768 3.7002 62.4 3.7002ZM47.5 17.6002C47.5 9.37115 54.171 2.7002 62.4 2.7002C70.629 2.7002 77.3 9.37115 77.3 17.6002C77.3 25.8292 70.629 32.5002 62.4 32.5002C54.171 32.5002 47.5 25.8292 47.5 17.6002Z"
        fill="#1C1C1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.4371 12.4472C70.6323 12.6425 70.6323 12.9591 70.4371 13.1543L60.4836 23.1078L55.33 17.9543C55.1348 17.759 55.1348 17.4425 55.33 17.2472C55.5253 17.0519 55.8419 17.0519 56.0371 17.2472L60.4836 21.6936L69.7299 12.4472C69.9252 12.252 70.2418 12.252 70.4371 12.4472Z"
        fill="#1C1C1C"
      />
    </svg>
  )
}
